import React from "react";
import { Box } from "@mui/material";
import { UsersTable } from "components/organisms/UsersTable/UsersTable";

export const Users = () => (
  <Box>
    <UsersTable />
  </Box>
);
